import { useQuery } from 'react-query';
import { LiveFeedEventSponsor } from '../domain';
import { apiHttpService } from './apiHttpService';
import { useEventFeed } from './useEventFeed';

export function useEventAds(eventId: string | null | undefined) {
  const { dataUpdatedAt: eventFeedUpdatedAt } = useEventFeed({ eventId });

  return useQuery<LiveFeedEventSponsor[]>(
    ['ads', eventId, eventFeedUpdatedAt],
    () =>
      apiHttpService
        .get<{
          ads: LiveFeedEventSponsor[];
        }>(`/GetEventAd?eventId=${eventId}`)
        .then((data) => data.data.ads),
    { enabled: Boolean(eventId && eventFeedUpdatedAt) },
  );
}
